import { appConfig } from "src/config";
import { useTranslate } from "src/i18n";

export const useApiDocsPageTranslate = () => {
  const { t } = useTranslate();

  return {
    title: t("apiDocsPage.title", "{brand} · Консоль · Документация", {
      brand: appConfig.displayName,
    }),
    comingSoonTitle: t("apiDocsPage.comingSoonTitle", "Скоро появится"),
    comingSoonText: t(
      "apiDocsPage.comingSoonText",
      "Документация этого API находится в разработке и будет доступна в ближайшее время.",
    ),
  };
};
